import { useId } from "react";

import { weekdayEs } from "../lib/dateFormat";

interface CalendarDateFieldProps {
  /** Fecha elegida (YYYY-MM-DD). */
  value: string;
  onChange: (value: string) => void;
  /** Hoy (YYYY-MM-DD), para avisar cuando la fecha elegida es otro día. */
  today: string;
  label?: string;
}

/** Campo Fecha de los calendarios (torneo y Canchas), resaltado: todo el
 * grid depende de él y Eduardo se perdía (2026-10-01: «resaltar el campo de
 * fecha porque me ha pasado que me pierdo»). Debajo dice el día de la semana
 * y si es hoy o no; el aviso describe el estado (data-no-toast). */
export default function CalendarDateField({ value, onChange, today, label = "Fecha" }: CalendarDateFieldProps) {
  const inputId = useId();
  const noteId = `${inputId}-dia`;
  const weekday = weekdayEs(value);
  const isToday = Boolean(value) && value === today;
  return (
    <div
      className={`schedule-toolbar__field schedule-calendar__date-field${weekday && !isToday ? " is-other-day" : ""}`}
      data-calendar-date-field
    >
      <label className="schedule-toolbar__label" htmlFor={inputId}>
        {label}
      </label>
      <input
        id={inputId}
        type="date"
        value={value}
        onChange={(event) => onChange(event.target.value)}
        aria-describedby={noteId}
      />
      <small id={noteId} className="schedule-calendar__date-note" data-no-toast>
        {weekday ? (
          <>
            {weekday} · <strong>{isToday ? "Hoy" : "No es hoy"}</strong>
          </>
        ) : (
          "Elige el día que vas a programar"
        )}
      </small>
    </div>
  );
}
